import { useHistory, useLocation } from "react-router-dom";
import React from "react";

export const useRedirect = () => {
	const location = useLocation();
	const history = useHistory();

	const redirectToHome = () => {
		history.push("/home");
	};

	const redirectToPreviousRoute = () => {
		if (
			location.pathname.includes([
				"/welcome",
				"/signin",
				"/signup",
				"/recover",
			])
		) {
			history.push("/home");
		} else {
			history.goBack();
		}
	};
	return { redirectToPreviousRoute, redirectToHome };
};
